import React, { useState } from "react";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import { useTranslation } from "react-i18next";

const ConfirmationPopup = ({ isOpen, onClose, onConfirm = null, confirmationText, eventObj }) => {
  const { t } = useTranslation();
  const [isConfirming, setIsConfirming] = useState(false);
  const cancelButtonProps = {
    buttonText: t("popup.cancel"),
    onClick: onClose,
    buttonType: "outlined",
    buttonColor: "#A62B23",
    textColor: "#A62B23",
  };

  let buttonConfigs = [];

  const handleConfirm = async () => {
    if (isConfirming) return; // Prevent double click

    setIsConfirming(true);

    try {
      await onConfirm(eventObj);
      onClose();
    } catch (error) {
      alert(error);
    } finally {
      setIsConfirming(false);
    }
  };
  if (onConfirm) {
    const confirmButtonProps = {
      buttonText: t("popup.delete"),
      onClick: handleConfirm,
      buttonType: "filled",
      buttonColor: "#A62B23",
      textColor: "#fff",
    };
    buttonConfigs = [cancelButtonProps, confirmButtonProps];
  } else {
    buttonConfigs = [cancelButtonProps];
  }

  if (!isOpen) return null;
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <p>{confirmationText}</p>
        <div className="button-group">
          <ButtonGroup buttons={buttonConfigs} />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
